import React from "react";

export default function OverlayBase(props: { hide: () => void, children: React.ReactNode, w?: string, noPadding?: boolean }) {

    function close(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
        if (e.target === e.currentTarget) {
            props.hide()
        }
    }

    return (
        <div
            className="size-full inset-0 bg-neutral-800 bg-opacity-50 flex items-center justify-center z-50 absolute top-0 left-0 right-0 bottom-0
            overflow-hidden sm:py-12 box-border"
            onClick={close}>
            <div className={`bg-neutral-900 border-neutral-500 border rounded-lg shadow-lg overflow-y-auto max-h-full relative ${props.w ?? "w-96"} ${props.noPadding ? "" : "p-4"}
            [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:rounded-md [&::-webkit-scrollbar-track]:bg-neutral-600
            [&::-webkit-scrollbar-thumb]:rounded-md [&::-webkit-scrollbar-thumb]:bg-neutral-400`}>
                <button className={`bg-red-500 hover:bg-red-600 px-1.5 flex rounded-md text-white z-10 ${props.noPadding ? "absolute top-2 right-2" : "float-right"}`} onClick={() => props.hide()}>&#10005;</button>
                {props.children}
            </div>
        </div>
    )
}